import React, { FC } from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./Card.module.scss";
import { ICard } from "./ICard";

const Card: FC<ICard.IProps> = ({ active, children, disabled, onClick }) => {
    return (
        <div
            className={classNames(
                styles.root,
                active && styles.active,
                disabled && styles.disabled
            )}
            onClick={disabled ? undefined : onClick}
        >
            {children}
        </div>
    );
};

export default Card;
